// extracted by mini-css-extract-plugin
module.exports = {"menu-items-selected":"styles_menu-items-selected__1hSfl","menu-items":"styles_menu-items__34ykJ"};